import Game from "./Game";
import Keyboard from "../utils/Keyboard";
import Piou from "./Piou";

export default class Debug {
  game: Game;
  constructor(game: Game) {
    this.game = game;

    Keyboard.down("Enter", () => {
      new Piou(this.game, this.game.mouse.x, this.game.mouse.y);
    });
    Keyboard.down("KeyH", () => {
      this.game.level.makeHole(this.game.mouse.x, this.game.mouse.y, 10);
    });
    Keyboard.down("KeyC", () => {
      this.game.level.cleanLevel();
    });
    Keyboard.down("KeyD", () => {
      console.log(this.game.sprites);
    });
  }
}
